/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_About_Method_Item2Inputs */

const ja_playdata_about_method_item2 = /** @type {(inputs: Playdata_About_Method_Item2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公式ウェブサイト、公式SNSアカウントなどから情報を収集。`)
};

const en_playdata_about_method_item2 = /** @type {(inputs: Playdata_About_Method_Item2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Information gathered from official websites and official social accounts.`)
};

/**
* | output |
* | --- |
* | "Information gathered from official websites and official social accounts." |
*
* @param {Playdata_About_Method_Item2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_about_method_item2 = /** @type {((inputs?: Playdata_About_Method_Item2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_About_Method_Item2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_about_method_item2(inputs)
	return en_playdata_about_method_item2(inputs)
});